<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <div class="card mb-0">
      <div class="card-body">
        <h3>Stato della registrazione aziendale:</h3>

        <div *ngIf="businessRegistrationStatus === 'CREATED'">
          <h2>Registrazione Aziendale Riuscita</h2>
          <p>La registrazione della tua azienda è stata inviata con successo ed è in attesa di approvazione.</p>


          <!-- Chat Button -->
          <button class="chat-button" (click)="openChat()">
            <span class="icon">📬</span> Contatta il Supporto
          </button>
        </div>

        <div *ngIf="businessRegistrationStatus === 'VERIFIED' || businessRegistrationStatus === 'COMPLETED'">
          <h4>Puoi fare acquisti</h4>
          <p>La tua registrazione aziendale è stata verificata e completata. Puoi fare acquisti ora.</p>
          <button class="btn btn-primary">Contatta il supporto</button>
        </div>

        <div *ngIf="businessRegistrationStatus === 'SUSPENDED'">
          <h4>Azienda sospesa</h4>
          <p>La tua attività è stata sospesa. Contatta il supporto per ulteriori informazioni.</p>
          <button class="btn btn-primary">Contatta il supporto</button>
        </div>

        <div *ngIf="businessRegistrationStatus === 'CANCELED'">
          <h4>Azienda cancellata</h4>
          <p>La tua azienda è stata cancellata. Contatta il supporto per ulteriori assistenze.</p>
          <button class="btn btn-primary">Contatta il supporto</button>
        </div>
      </div>
    </div>
  </div>
</div>
